import _extends from "@babel/runtime/helpers/extends";
import React, { useMemo, useState, useEffect } from 'react';
import Icon from '@uiw/react-icon';
import "./style/index.css";
import { noop } from '@uiw/utils';
import { locationFixed } from './util';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
export default function TableTr(props) {
  var {
    rowKey,
    data,
    keys,
    render,
    ellipsis,
    prefixCls,
    onCell = noop,
    isExpandedDom,
    hierarchy,
    indentSize,
    childrenColumnName,
    locationWidth,
    header
  } = props;
  var [isOpacity, setIsOpacity] = useState(false);
  var [childrenIndex, setChildrenIndex] = useState(0);
  var [expandIndex, setExpandIndex] = useState([]);
  useEffect(() => {
    setIsOpacity(!!(data != null && data.find(it => it[childrenColumnName])));
    setChildrenIndex((keys == null ? void 0 : keys.findIndex(it => it.key === 'uiw-expanded')) === -1 ? 0 : 1);
  }, [data]);
  var IconDom = useMemo(() => {
    return (key, isOpacity) => {
      var flag = expandIndex.includes(key);
      return /*#__PURE__*/_jsx(Icon, {
        type: flag ? 'minus-square-o' : 'plus-square-o',
        style: {
          marginRight: 10,
          opacity: isOpacity ? 1 : 0,
          marginLeft: hierarchy * indentSize,
          float: 'left',
          marginTop: 3.24
        },
        onClick: () => {
          setExpandIndex(flag ? expandIndex.filter(it => it !== key) : [...expandIndex, key]);
        }
      });
    };
  }, [expandIndex]);
  var getIndex = key => {
    var j = 0;
    var i = header.findIndex(it => {
      j = it.findIndex(item => item.key === key);
      return j > -1;
    });
    return "" + i + j;
  };
  if (!Array.isArray(data) || !data.length) {
    return null;
  }
  return /*#__PURE__*/_jsx(React.Fragment, {
    children: data.map((trData, rowNum) => {
      var key = rowKey ? trData[rowKey] : rowNum;
      var rightFixedNum = 0;
      return /*#__PURE__*/_jsxs(React.Fragment, {
        children: [/*#__PURE__*/_jsx("tr", {
          children: keys.map((keyName, colNum) => {
            var objs = {
              children: trData[keyName.key]
            };
            if (render[keyName.key]) {
              var child = render[keyName.key](trData[keyName.key], keyName.key, trData, rowNum, colNum);
              if ( /*#__PURE__*/React.isValidElement(child)) {
                objs.children = child;
              } else {
                if (child.props) {
                  objs = _extends({}, child.props, {
                    children: objs.children
                  });
                  if (child.props.rowSpan === 0 || child.props.colSpan === 0) return null;
                }
                if (child.children) {
                  objs.children = child.children;
                }
              }
            }
            var isHasChildren = Array.isArray(trData[childrenColumnName]);
            if (colNum === childrenIndex && (isOpacity || hierarchy || isHasChildren)) {
              objs.children = /*#__PURE__*/_jsxs(_Fragment, {
                children: [IconDom(key, isHasChildren), /*#__PURE__*/_jsx("span", {
                  style: {
                    paddingLeft: hierarchy * indentSize
                  }
                }), objs.children]
              });
            }
            if (keyName.fixed) {
              if (keyName.fixed === 'right') {
                rightFixedNum = rightFixedNum + 1;
                var cls = rightFixedNum === 1 ? prefixCls + "-fixed-right-first" : '';
                objs.className = prefixCls + "-fixed-right " + cls;
              } else {
                objs.className = prefixCls + "-fixed-true";
              }
            }
            return /*#__PURE__*/_createElement("td", _extends({}, objs, {
              style: keyName.fixed ? _extends({}, locationFixed(keyName.fixed, locationWidth, "" + getIndex(keyName.key || 'undefined'))) : {},
              children: /*#__PURE__*/_jsx("span", {
                className: ellipsis && ellipsis[keyName.key] ? prefixCls + "-ellipsis" : undefined,
                children: objs.children
              }),
              key: colNum,
              className: [prefixCls + '-tr-children-' + (keyName.align || 'left'), keyName.className, objs.className].filter(it => it).join(' ').trim(),
              onClick: evn => onCell(trData, {
                rowNum,
                colNum,
                keyName: keyName.key
              }, evn)
            }));
          })
        }, key), isExpandedDom(trData, rowNum), expandIndex.includes(key) && /*#__PURE__*/_jsx(TableTr, _extends({}, props, {
          data: trData[childrenColumnName],
          hierarchy: hierarchy + 1
        }))]
      }, rowNum);
    })
  });
}